import React from 'react';
import PropTypes from 'prop-types';

import {Calendar as RBCalendar, Views, momentLocalizer} from 'react-big-calendar';
import momentTimezone from 'moment-timezone';

import 'react-big-calendar/lib/sass/styles.scss';

const Calendar = (props) => {
  // Set default timezone if none is provided
  const timezone = props.timezone || momentTimezone.tz.guess();
  momentTimezone.tz.setDefault(timezone);
  const localizer = momentLocalizer(momentTimezone);

  React.useEffect(() => {
    return () => {
      momentTimezone.tz.setDefault(); // reset to browser TZ on unmount
    };
  }, []);

  return (
    <RBCalendar
      key={timezone}
      localizer={localizer}
      {...props}
    />
  );
};
Calendar.propTypes = {
  timezone: PropTypes.string, // Make the timezone prop optional
};
const MemoReact = React.memo(Calendar);

export {
  MemoReact as Calendar,
  Views,
};
